/* live-bump 2026-09-29 */
/**
 * PHOTO•MAGNET — write-a-review dialog with optional photo share.
 * Submits text via Shopify contact form, then shares/opens WhatsApp or email for the photo.
 */
const REVIEW_EMAIL = 'PhotoMagnetsupport@gmail.com';
const REVIEW_WHATSAPP = '14039231580';

function qs(root, sel) {
  return root.querySelector(sel);
}

function starLabel(n) {
  return `${'★'.repeat(n)}${'☆'.repeat(5 - n)}`;
}

class ReviewCompose {
  constructor(root) {
    this.root = root;
    this.dialog = qs(document, '[data-review-dialog]');
    this.form = this.dialog?.querySelector('form');
    this.rating = 5;
    this.photoFile = null;
    this.photoObjectUrl = null;
    if (!this.dialog || !this.form) return;
    this.bind();
    this.setRating(5);
  }

  bind() {
    document.querySelectorAll('[data-review-open]').forEach((btn) => {
      btn.addEventListener('click', () => this.open());
    });
    this.dialog.querySelectorAll('[data-review-close]').forEach((btn) => {
      btn.addEventListener('click', () => this.close());
    });
    this.dialog.addEventListener('click', (e) => {
      if (e.target === this.dialog) this.close();
    });
    this.dialog.querySelectorAll('[data-review-star]').forEach((btn) => {
      btn.addEventListener('click', () => this.setRating(Number(btn.dataset.reviewStar)));
    });

    const photoInput = qs(this.dialog, '[data-review-photo]');
    const photoTrigger = qs(this.dialog, '[data-review-photo-trigger]');
    photoTrigger?.addEventListener('click', () => photoInput?.click());
    photoInput?.addEventListener('change', () => this.onPhoto(photoInput.files?.[0]));

    this.form.addEventListener('submit', (e) => this.onSubmit(e));
  }

  open() {
    this.clearMessages();
    if (typeof this.dialog.showModal === 'function') this.dialog.showModal();
    else this.dialog.setAttribute('open', '');
    document.documentElement.classList.add('review-compose-open');
  }

  close() {
    if (typeof this.dialog.close === 'function') this.dialog.close();
    else this.dialog.removeAttribute('open');
    document.documentElement.classList.remove('review-compose-open');
  }

  setRating(n) {
    this.rating = Math.min(5, Math.max(1, n));
    const field = qs(this.dialog, '[data-review-rating-field]');
    if (field) field.value = String(this.rating);
    this.dialog.querySelectorAll('[data-review-star]').forEach((btn) => {
      const v = Number(btn.dataset.reviewStar);
      btn.classList.toggle('is-active', v <= this.rating);
      btn.setAttribute('aria-checked', v === this.rating ? 'true' : 'false');
    });
  }

  onPhoto(file) {
    const preview = qs(this.dialog, '[data-review-photo-preview]');
    if (this.photoObjectUrl) URL.revokeObjectURL(this.photoObjectUrl);
    this.photoFile = null;
    this.photoObjectUrl = null;
    if (!file || !file.type.startsWith('image/')) {
      preview.hidden = true;
      preview.innerHTML = '';
      return;
    }
    this.photoFile = file;
    this.photoObjectUrl = URL.createObjectURL(file);
    preview.hidden = false;
    preview.innerHTML = `<img src="${this.photoObjectUrl}" alt="Selected review photo">`;
  }

  clearMessages() {
    const err = qs(this.dialog, '[data-review-error]');
    const ok = qs(this.dialog, '[data-review-success]');
    if (err) {
      err.hidden = true;
      err.textContent = '';
    }
    if (ok) ok.hidden = true;
  }

  showError(msg) {
    const err = qs(this.dialog, '[data-review-error]');
    if (!err) return;
    err.hidden = false;
    err.textContent = msg;
  }

  buildMessage() {
    const name = this.form.elements.namedItem('contact[name]')?.value?.trim() || '';
    const text = qs(this.dialog, '[data-review-text]')?.value?.trim() || '';
    return [
      `New customer review from ${name}`,
      `Rating: ${this.rating}/5 ${starLabel(this.rating)}`,
      '',
      text,
      this.photoFile ? '' : '',
      this.photoFile ? `(Customer selected a photo: ${this.photoFile.name})` : '',
    ]
      .filter((line, i, arr) => !(line === '' && arr[i - 1] === ''))
      .join('\n');
  }

  async sharePhoto(message) {
    if (!this.photoFile) return false;
    const shareData = {
      files: [this.photoFile],
      title: 'PHOTO•MAGNET review',
      text: message,
    };
    if (navigator.canShare?.(shareData)) {
      try {
        await navigator.share(shareData);
        return true;
      } catch (e) {
        if (e?.name === 'AbortError') return true;
      }
    }
    return false;
  }

  openWhatsApp(message) {
    const url = `https://wa.me/${REVIEW_WHATSAPP}?text=${encodeURIComponent(message)}`;
    window.open(url, '_blank', 'noopener,noreferrer');
  }

  openEmail(message) {
    const subject = encodeURIComponent('PHOTO•MAGNET customer review');
    const body = encodeURIComponent(
      message +
        (this.photoFile
          ? '\n\nPlease attach the fridge photo you selected in the review form.'
          : '')
    );
    window.location.href = `mailto:${REVIEW_EMAIL}?subject=${subject}&body=${body}`;
  }

  async onSubmit(e) {
    e.preventDefault();
    this.clearMessages();

    if (!this.rating) {
      this.showError('Please choose a star rating.');
      return;
    }

    const name = this.form.elements.namedItem('contact[name]')?.value?.trim();
    const email = this.form.elements.namedItem('contact[email]')?.value?.trim();
    const text = qs(this.dialog, '[data-review-text]')?.value?.trim();
    if (!name || !email || !text) {
      this.showError('Please fill in your name, email, and review.');
      return;
    }

    const message = this.buildMessage();
    const bodyField = qs(this.dialog, '[data-review-body-field]');
    if (bodyField) bodyField.value = message;

    const submitBtn = qs(this.dialog, '[data-review-submit]');
    if (submitBtn) {
      submitBtn.disabled = true;
      submitBtn.textContent = 'Sending…';
    }

    try {
      const formData = new FormData(this.form);
      // Shopify contact forms expect contact[body] as the message body
      if (!formData.get('contact[body]')) formData.set('contact[body]', message);

      const res = await fetch(this.form.action || window.location.pathname, {
        method: 'POST',
        body: formData,
        headers: { Accept: 'application/json' },
      });

      // Shopify may return HTML redirect; treat network OK as success
      if (!res.ok && res.status >= 500) {
        throw new Error('Could not send review. Please try WhatsApp or email.');
      }

      const ok = qs(this.dialog, '[data-review-success]');
      if (ok) ok.hidden = false;

      const shared = await this.sharePhoto(message);
      if (!shared && this.photoFile) {
        // Prefer WhatsApp so the customer can attach the fridge photo easily
        this.openWhatsApp(
          `${message}\n\n(Please attach your fridge photo to this chat.)`
        );
      } else if (!this.photoFile) {
        // text-only is enough via contact form; nothing else required
      }
    } catch (err) {
      this.showError(err?.message || 'Something went wrong. Try again or email us.');
      // Fallback channels so the review still gets through
      if (this.photoFile) this.openWhatsApp(`${message}\n\n(Please attach your fridge photo.)`);
      else this.openEmail(message);
    } finally {
      if (submitBtn) {
        submitBtn.disabled = false;
        submitBtn.textContent = 'Send review';
      }
    }
  }
}

function init() {
  const section = document.querySelector('#shopify-product-reviews');
  if (!section || section.dataset.reviewInit === '1') return;
  section.dataset.reviewInit = '1';
  new ReviewCompose(section);
}

if (document.readyState === 'loading') {
  document.addEventListener('DOMContentLoaded', init);
} else {
  init();
}
